import GLightbox from 'glightbox';

let ProductGallery = {};

ProductGallery.init = () => {
    const galleries = document.querySelectorAll('[data-module="product-gallery"]');

    const getChildElementIndex = (node) => {
        return Array.prototype.indexOf.call(node.parentNode.children, node);
    }

    galleries.forEach((gallery) => {
        const mainImage = gallery.querySelector('.product__image img');
        const open = gallery.querySelector('.product__gallery--open');
        const prev = gallery.querySelector('.product__gallery--prev');
        const next = gallery.querySelector('.product__gallery--next');
        const images = gallery.querySelector('.product__images')

        images.querySelectorAll('img').forEach((image) => {
            image.addEventListener('click', (e) => {
                e.preventDefault();
                mainImage.setAttribute('src', e.target.getAttribute('src'));
            });
        });

        prev.addEventListener('click', (e) => {
            e.preventDefault();
            const src = mainImage.getAttribute('src');
            const current = images.querySelector(`[src="${src}"]`);
            let prevElement = current.previousElementSibling;
            if (!prevElement) {
                prevElement = images.lastElementChild;
            }
            mainImage.setAttribute('src', prevElement.getAttribute('src'));
        });

        next.addEventListener('click', (e) => {
            e.preventDefault();
            const src = mainImage.getAttribute('src');
            const current = images.querySelector(`[src="${src}"]`);
            let nextElement = current.nextElementSibling;
            if (!nextElement) {
                nextElement = images.firstElementChild;
            }
            mainImage.setAttribute('src', nextElement.getAttribute('src'));
        });

        const glightbox = GLightbox({
            elements: [...images.querySelectorAll('img')].map((image) => (
                {
                    'href': image.getAttribute('src'),
                    'type': 'image',
                }
            )),
            touchNavigation: true,
            loop: true,
        });

        open.addEventListener('click', (e) => {
            e.preventDefault();

            const src = mainImage.getAttribute('src');
            const current = images.querySelector(`[src="${src}"]`);

            glightbox.openAt(getChildElementIndex(current));
        });
    });

}

ProductGallery.init();

export default ProductGallery;
